<template>
  <v-app id="app-demo">
    <div id="middle-magnet"></div>

    <div id="bottom-magnet"></div>
    <div id="bottom-magnet-2"></div>
    <div id="top-magnet"></div>
    <div id="top-magnet-1"></div>
    <v-container id="top-nav-container" ref="tour-icon-container" pa-0 mt-2>
      <v-layout v-if="showTopNav" align-center justify-space-between row mx-1>
        <v-flex pt-1 justify-center d-flex id="tour-icon-1">
          <v-layout column justify-center align-center>
            <v-flex v-if="pinActive === 'rest1'">
              <v-img :src="TourPin" width="16px" height="25px"/>
            </v-flex>
            <v-flex v-else>
              <v-avatar size="20"></v-avatar>
            </v-flex>
            <v-flex>
              <v-avatar :size="tourIconWidth">
                <v-img :src="rest1"/>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex pt-1 justify-center d-flex id="tour-icon-2">
          <v-layout column justify-center align-center>
            <v-flex v-if="pinActive === 'rest2'">
              <v-img :src="TourPin" width="16px" height="25px"/>
            </v-flex>
            <v-flex v-else>
              <v-avatar size="20"></v-avatar>
            </v-flex>
            <v-flex>
              <v-avatar :size="tourIconWidth">
                <v-img :src="rest2"/>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex pt-1 justify-center d-flex id="tour-icon-3">
          <v-layout column justify-center align-center>
            <v-flex v-if="pinActive === 'rest3'">
              <v-img :src="TourPin" width="16px" height="25px"/>
            </v-flex>
            <v-flex v-else>
              <v-avatar size="20"></v-avatar>
            </v-flex>
            <v-flex>
              <v-avatar :size="tourIconWidth">
                <v-img :src="rest3"/>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex pt-1 justify-center d-flex id="tour-icon-4">
          <v-layout column justify-center align-center>
            <v-flex>
              <v-avatar size="20"></v-avatar>
            </v-flex>
            <v-flex>
              <v-avatar :size="tourIconWidth">
                <v-img :src="rest4"/>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex pt-1 justify-center d-flex id="tour-icon-5">
          <v-layout column justify-center align-center>
            <v-flex>
              <v-avatar size="20"></v-avatar>
            </v-flex>
            <v-flex>
              <v-avatar :size="tourIconWidth" @click.stop>
                <v-img :src="rest5"/>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex pt-1 justify-center d-flex id="tour-icon-6">
          <v-layout column justify-center align-center>
            <v-flex>
              <v-avatar size="20"></v-avatar>
            </v-flex>
            <v-flex>
              <v-avatar :size="tourIconWidth">
                <v-img :src="rest6"/>
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-content id="app-container">
      <v-tour name="myTour" :steps="steps" :callbacks="myCallbacks"></v-tour>
    </v-content>

    <v-container id="navigation-demo" v-if="showBottomNav" fluid pa-0>
      <div id="bottom-menu-background" :class="{open: isOpen}">
        <transition name="more-trans" mode="out-in">
          <v-btn
            v-if="!isOpen"
            id="upper-nav-more-button"
            flat
            class="red--text"
            :disabled="disableMore"
            @click="isOpen = true"
          >
            MORE
            <v-icon medium dark>arrow_drop_up</v-icon>
          </v-btn>
        </transition>
        <transition name="more-trans">
          <v-btn
            v-if="isOpen"
            id="upper-nav-more-button"
            flat
            class="red--text"
            :disabled="disableMore"
            @click="isOpen = false"
          >
            LESS
            <v-icon medium dark>arrow_drop_down</v-icon>
          </v-btn>
        </transition>
        <v-layout justify-center align-center row no-wrap id="bottom-nav-upper" color="transparent">
          <v-flex xs3 class="nav-button" px-2>
            <transition name="fade">
              <div key="suspect-active" v-if="active === 'suspects'">
                <v-badge :value="clues" overlap color="#AE250A">
                  <span id="badge" slot="badge">{{clues}}</span>
                  <img :src="suspectsNavActive">
                </v-badge>
              </div>
            </transition>
            <div key="suspect-inactive" class="inactive suspects-nav" v-if="active !== 'suspects'">
              <v-badge :value="clues" overlap color="#AE250A">
                <span id="badge" slot="badge">{{clues}}</span>
                <img :src="suspectsNavInactive">
              </v-badge>
            </div>
          </v-flex>

          <v-flex xs3 class="nav-button" px-2>
            <transition name="fade">
              <div v-if="active==='tour'">
                <img :src="tourNavActive">
              </div>
            </transition>
            <div class="inactive tour-nav" v-if="active !== 'tour'">
              <img :src="tourNavInactive">
            </div>
          </v-flex>

          <v-flex xs3 class="nav-button" px-2>
            <transition name="fade">
              <div v-if="active === 'map'">
                <img :src="mapNavActive">
              </div>
            </transition>
            <div class="inactive map-nav" v-if="active !== 'map'">
              <img :src="mapNavInactive">
            </div>
          </v-flex>

          <v-flex xs3 class="nav-button" px-2>
            <transition name="fade">
              <div v-if="active === 'help'">
                <img :src="helpNavActive">
              </div>
            </transition>
            <div class="inactive help-nav" v-if="active !== 'help'">
              <img :src="helpNavInactive">
            </div>
          </v-flex>
        </v-layout>
        <v-bottom-nav
          id="bottom-nav-lower"
          :active.sync="activeBottom"
          height="40"
          value="yes"
          color="transparent"
          class="bebas"
        >
          <v-btn color="black" flat value="faqs">
            <span class="subheading">FAQs</span>
          </v-btn>
          <v-btn color="black" flat value="restart">
            <span class="subheading">Trouble-Shooting</span>
          </v-btn>

          <v-btn color="black" flat value="credits">
            <span class="subheading">Credits</span>
          </v-btn>

          <v-btn color="#AE250A" flat value="logout">
            <span class="subheading">Logout</span>
          </v-btn>
        </v-bottom-nav>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import suspectsNavActive from "@/assets/suspects2.png";
import tourNavInactive from "@/assets/tour1.png";
import tourNavActive from "@/assets/tour2.png";
import suspectsNavInactive from "@/assets/suspects1.png";
import mapNavInactive from "@/assets/map1.png";
import mapNavActive from "@/assets/map2.png";
import helpNavInactive from "@/assets/help1.png";
import helpNavActive from "@/assets/help2.png";
import TourPin from "@/assets/tourpin.png";
import savoryActive from "@/assets/restaurantIcons/active/savory_active.png";
import sweetActive from "@/assets/restaurantIcons/active/sweet_active.png";
import noneActive from "@/assets/restaurantIcons/active/store_active.png";
import savoryInactive from "@/assets/restaurantIcons/inactive/savory_inactive.png";
import sweetInactive from "@/assets/restaurantIcons/inactive/sweet_inactive.png";
import noneInactive from "@/assets/restaurantIcons/inactive/store_inactive.png";
import fullGlassIcon from "@/assets/bottomNavIcons/full_glass_icon.png";
import suspectsWithIcon from "@/assets/suspects_with_red_icon.png";
import moreIcon from "@/assets/more_USE.png";
import lessIcon from "@/assets/less_USE.png";

export default {
  name: "AppDemo",
  data() {
    return {
      disableMore: true,
      pinActive: null,
      showTopNav: false,
      tourIconWidth: "",
      active: "",
      activeBtn: 1,
      showNavShelf: false,
      showNav: true,
      dialog: false,
      show: false,
      isOpen: false,
      activeBottom: "logout",
      suspectsNavInactive,
      suspectsNavActive,
      fullGlassIcon,
      helpNavInactive,
      mapNavInactive,
      mapNavActive,
      tourNavInactive,
      tourNavActive,
      helpNavActive,
      suspectsWithIcon,
      moreIcon,
      lessIcon,
      rest1: savoryInactive,
      rest2: sweetInactive,
      rest3: noneInactive,
      rest4: savoryInactive,
      rest5: savoryInactive,
      rest6: sweetInactive,
      TourPin,
      clues: null,
      showBottomNav: false,
      steps: [
        // 01
        {
          target: "#top-magnet-1",
          content:
            "Hello Detectives! Welcome to your Fooddoneit App Demo.<br><br>If you have already seen this or at any moment during the demo click <strong>Skip Tour</strong> to exit.<br><br>Click <strong>Previous</strong> to go back to previously displayed demo examples.<br/><br/>Click <strong>Next</strong> to continue through the demo showcase to get a brief explanation about application functionality.",
          params: {
            placement: "top"
          }
        },
        {
          target: "#top-magnet",
          content: `<br>Once on your Tour Page, you will see the following set of icons, which each represent a different stop along your Edible Mystery Tour.<br>`,
          params: {
            placement: "bottom"
          }
        },
        {
          target: "#tour-icon-3",
          content: `<br>The type of icon will give you insight into what kind of food you should expect at this stop.<br><br><img src=${savoryInactive} height="35"/><br>Expect a Savory Dish<br><br><img src=${sweetInactive} height="35"/><br>Expect a Sweet Dish<br><br><img src=${noneInactive} height="35"/><br>A Non-Food stop<br><br>`,
          params: {
            placement: "bottom"
          }
        },
        {
          target: "#tour-icon-1",
          content: `<img src=${TourPin} width="30"/><br>Your current stop will show an icon with a black background and have the navigation pin above it.`,
          params: {
            placement: "bottom"
          }
        },
        {
          target: "#tour-icon-3",
          content: `<br>All stops on the tour that have been previously experienced have the icon with the black background.  You can click on these (black background) icons to jump between tour stops (if you need to go over some information again).`,
          params: {
            placement: "bottom"
          }
        },
        // 1
        {
          target: "#top-magnet-1",
          content: `<div style="background-color: #D6B682; padding: 5px 5px"><img src=${fullGlassIcon} height="35"/></div><br>Your main application controls are here on the Bottom Navigation panel.<br><br>Active tabs will have a special magnifying glass overlay.<br><br>`,
          params: {
            placement: "bottom"
          }
        },
        // 2
        {
          target: "#top-magnet-1",
          content: `<div style="background-color: #D6B682; padding-top: 10px;"><img src=${tourNavInactive} height="35"/></div><br>The <strong>Tour</strong> button takes you to your Food Done It Edible Mystery Tour Digital Companion.<br><br>`,
          params: {
            placement: "bottom"
          }
        },
        // 3
        {
          target: "#top-magnet-1",
          content: `<div style="background-color: #D6B682; padding-top: 10px;"><img src=${suspectsNavInactive} height="35"/></div><br>The <strong>Suspects</strong> button takes you to your Suspects Page, where you will find a dynamically updated Suspects list with supplemental clues.<br><br>`,
          params: {
            placement: "bottom"
          }
        },
        // 4
        {
          target: "#top-magnet-1",
          content: `<img src=${suspectsWithIcon} height="50"/><br><br>As you continue through your tour, Suspects and Clues get activated. When this new information is available you will be notified with a small red icon with the number of new clues.  If you see this, click the Suspects Tab and find your new clue.<br>`,
          params: {
            placement: "bottom"
          }
        },
        // 5
        {
          target: "#top-magnet-1",
          content: `<div style="background-color: #D6B682; padding-top: 10px;"><img src=${mapNavInactive} height="35"/></div><br>The <strong>Map</strong> button takes you to your live embedded Google Maps.  Use this map to find your way if you happen to get lost or just like to see where you are heading.<br><br>`,
          params: {
            placement: "bottom"
          }
        },
        {
          target: "#top-magnet-1",
          content: `<div style="background-color: #D6B682; padding-top: 10px;"><img src=${helpNavInactive} height="35"/></div><br>The <strong>Help</strong> button will open a pop-up window that enables you to send a live message to your FDI Director via text.<br><br>`,
          params: {
            placement: "bottom"
          }
        },
        {
          target: "#top-magnet-1",
          content: `<div style="background-color: #D6B682; padding-top: 10px;"><img style="margin-right: 10px;" src=${moreIcon} width="40"/><img src=${lessIcon} width="40"/></div><br>Clicking <strong>More / Less</strong> will open or close the lower part of the controls menu.`,
          params: {
            placement: "bottom"
          }
        },
        {
          target: "#top-magnet-1",
          content: `<div style="text-align: left">This Lower Menu gives you access to:<br><br><ol><li><strong>Frequently Asked Questions:</strong> <br> A curated list of popular questions and information</li><li>Trouble-Shooting<br>Key Actions to help with application issues</li><li>Credits</li><li>Logout</li></ul><br><br>`,
          params: {
            placement: "bottom"
          }
        },
        {
          target: "#top-magnet",
          content: `That sums up your Food Done It App demo-tour, if you have any more questions click on the FAQs button in your bottom navigation.  There you will find more detailed information and customer questions.`,
          params: {
            placement: "top"
          }
        }
      ],
      myCallbacks: {
        onPreviousStep: this.myCustomPreviousStepCallback,
        onNextStep: this.myCustomNextStepCallback,
        onStop: this.myCustomOnStopCallback
      }
    };
  },
  mounted: function() {
    this.$tours["myTour"].start();
    this.calculateFlexWidth();
  },

  methods: {
    calculateFlexWidth() {
      this.tourIconWidth =
        (this.$refs["tour-icon-container"].clientWidth - 5 * 6) / 6;
    },
    myCustomPreviousStepCallback(currentStep) {
      switch (currentStep) {
        case 1:
          this.showTopNav = false;
          this.showBottomNav = false;
          break;
        case 2:
          this.active = "tour";
          this.showBottomNav = true;
          break;
        case 3:
          this.pinActive = null;
          this.rest1 = savoryInactive;
          break;
        case 4:
          this.pinActive = "rest1";
          this.rest1 = savoryActive;
          this.rest2 = sweetInactive;
          this.rest3 = noneInactive;
          break;
        case 5:
          this.showBottomNav = false;
          this.showTopNav = true;
          this.pinActive = "rest3";
          this.rest1 = savoryActive;
          this.rest2 = sweetActive;
          this.rest3 = noneActive;
          break;
        case 6:
          this.clues = null;
          this.active = "help";
          break;
        case 7:
          this.active = "tour";
          break;
        case 8:
          this.active = "suspects";
          this.disableMore = true;
          this.clues = null;
          break;
        case 9:
          this.open = false;
          this.active = "suspects";
          this.clues = 4;
          break;
        case 10:
          this.active = "map";
          break;
        case 11:
          this.disableMore = true;
          this.active = "help";
          break;
        case 12:
          this.isOpen = false;
          break;
        case 13:
          this.isOpen = true;
          this.showBottomNav = true;
      }
    },
    myCustomNextStepCallback(currentStep) {
      switch (currentStep) {
        case 0:
          this.showBottomNav = true;
          this.active = "tour";
          this.showTopNav = true;
          break;
        case 1:
          this.showBottomNav = false;
          break;
        case 2:
          this.pinActive = "rest1";
          this.rest1 = savoryActive;
          break;
        case 3:
          this.pinActive = "rest3";
          this.rest1 = savoryActive;
          this.rest2 = sweetActive;
          this.rest3 = noneActive;
          break;
        case 4:
          this.showTopNav = false;
          this.showBottomNav = true;
          this.active = "help";
          break;
        case 5:
          this.active = "tour";
          break;
        case 6:
          this.active = "suspects";
          break;
        case 7:
          this.clues = 4;
          break;
        case 8:
          this.clues = null;
          this.active = "map";
          break;
        case 9:
          this.active = "help";
          break;
        case 10:
          this.active = "";
          this.disableMore = false;
          break;
        case 11:
          this.isOpen = true;
          break;
        case 12:
          this.isOpen = false;
          this.disableMore = true;
          this.showBottomNav = false;
      }
    },
    myCustomOnStopCallback(currentStep) {
      this.$router.push("/tour");
      this.$store.dispatch("setDemoRequest", false);
    }
  }
};
</script>

<style scoped>
#navigation-demo {
}

#app-demo {
  background-image: url("../assets/backgrounds/brick-blk.png");
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
}

#top-nav-container {
  background-color: Transparent;
  position: absolute;
  top: 0;
  z-index: 50;
}

#app-container {
  height: 100%;
  width: 100%;
  position: relative;
}

#navigation-demo {
  width: 100%;
  background: transparent;
  position: relative;
  bottom: 0;
  font-family: "BebasNeue-Regular";
}

#badge {
  font-family: "BebasNeue-Regular";
  display: block;
  margin-top: 5px;
}

#navigation .v-bottom-nav .v-btn {
  padding: 8px 0px 10px;
}

.nav-button {
  height: 100%;
}

.nav-button img {
  max-width: 75px;
  max-height: 100%;
  display: block;
}

.nav-button .inactive {
  margin-top: 14px;
}

.nav-button .inactive.suspects-nav img {
  max-width: 67%;
  max-height: 100%;
  margin: auto auto;
  padding-top: 2px;
}

.nav-button .inactive.tour-nav img {
  max-width: 33%;
  max-height: 100%;
  margin: auto auto;
  padding-top: 3px;
}

.nav-button .inactive.map-nav img {
  max-width: 44%;
  max-height: 100%;
  margin: auto auto;
  padding-top: 3px;
}

.nav-button .inactive.help-nav img {
  max-width: 40%;
  max-height: 100%;
  margin: auto auto;
  padding-top: 4px;
}

.nav-button .inactive span {
  display: block;
  margin: auto auto;
  text-align: center;
  font-size: 13px;
  line-height: 1.2;
  letter-spacing: -1px;
}

#bottom-nav-upper {
  position: absolute;
  bottom: 45px;
  font-family: "1942";
  height: 90px;
  width: 100%;
}

#bottom-nav-upper .nav-button {
  position: relative;
  top: 10px;
}

#bottom-nav-lower {
  position: absolute;
  bottom: 0px;
  font-family: "1942";
  font-weight: "bold";
}

#navigation .v-bottom-nav {
  box-shadow: none;
}

#bottom-menu-background.open {
  transition: bottom 700ms;
  bottom: 0px;
}

#bottom-menu-background {
  background-image: url("../assets/folder_expand.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 170px;
  position: absolute;
  transition: bottom 500ms;
  bottom: -45px;
}

#bottom-menu-buttons {
  position: relative;
  bottom: 0px;
}

#bottom-shelf {
  width: 100%;
  height: 40px;
  background-color: #e9d1b0;
  position: relative;
}

.fade-enter-active {
  transition: all 0.75s;
}

.fade-enter {
  transform: scale(2);
}

.fade-enter-to {
  transform: scale(1);
}

.more-trans-enter-active {
  transition: all 1000ms;
}

.more-trans-leave-active {
  transition: all 0ms;
}

.more-trans-enter {
  opacity: 0;
}

.more-trans-leave {
  opacity: 0.05;
}

.more-trans-enter-to {
  opacity: 1;
}

.more-trans-leave-to {
  opacity: 0;
}

.slide-in-bottom {
  -webkit-animation: slide-in-bottom 0.5s ease-in both;
  animation: slide-in-bottom 0.5s ease-in both;
}

.slide-out-bottom {
  -webkit-animation: slide-in-bottom 0.5s ease-out reverse both;
  animation: slide-in-bottom 0.5s ease-out reverse both;
}

@-webkit-keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(250px);
    transform: translateY(250px);
    opacity: 1;
    z-index: 50;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
    z-index: 50;
  }
}

@keyframes slide-in-bottom {
  0% {
    -webkit-transform: translateY(250px);
    transform: translateY(250px);
    opacity: 1;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@-webkit-keyframes slide-out-bottom {
  0% {
    -webkit-transform: translateY(1000px);
    transform: translateY(1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out-bottom {
  0% {
    -webkit-transform: translateY(1000px);
    transform: translateY(1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

#middle-magnet {
  position: fixed;
  top: 30%;
  left: 50%;
}

#bottom-magnet {
  position: fixed;
  bottom: 125px;
  left: 50%;
}

#bottom-magnet-2 {
  position: fixed;
  bottom: 175px;
  left: 50%;
}

#top-magnet {
  position: fixed;
  top: 125px;
  left: 50%;
}

#top-magnet-1 {
  position: fixed;
  top: 50px;
  left: 50%;
}
</style>
